/**
 * Thin wrappers around the /api/wealth/* endpoints.
 * Uses the same apiClient that auth uses so tokens are attached automatically.
 */
import { apiClient } from './apiClient';

export const wealthApi = {
  // Asset classes
  getAssetClasses: () => apiClient.get('/wealth/asset-classes'),
  createAssetClass: (data) => apiClient.post('/wealth/asset-classes', data),
  updateAssetClass: (id, data) => apiClient.patch(`/wealth/asset-classes/${id}`, data),
  deleteAssetClass: (id) => apiClient.delete(`/wealth/asset-classes/${id}`),

  // Assets
  getAssets: () => apiClient.get('/wealth/assets'),
  createAsset: (data) => apiClient.post('/wealth/assets', data),
  updateAsset: (id, data) => apiClient.patch(`/wealth/assets/${id}`, data),
  deleteAsset: (id) => apiClient.delete(`/wealth/assets/${id}`),

  // Liability classes
  getLiabilityClasses: () => apiClient.get('/wealth/liability-classes'),
  createLiabilityClass: (data) => apiClient.post('/wealth/liability-classes', data),
  updateLiabilityClass: (id, data) => apiClient.patch(`/wealth/liability-classes/${id}`, data),
  deleteLiabilityClass: (id) => apiClient.delete(`/wealth/liability-classes/${id}`),

  // Liabilities
  getLiabilities: () => apiClient.get('/wealth/liabilities'),
  createLiability: (data) => apiClient.post('/wealth/liabilities', data),
  updateLiability: (id, data) => apiClient.patch(`/wealth/liabilities/${id}`, data),
  deleteLiability: (id) => apiClient.delete(`/wealth/liabilities/${id}`),

  // Snapshots
  getSnapshots: () => apiClient.get('/wealth/snapshots'),
  createSnapshot: (year, month) => apiClient.post('/wealth/snapshots', { year, month }),
  deleteSnapshot: (id) => apiClient.delete(`/wealth/snapshots/${id}`),

  // Cash hint
  getCashHint: (year, month) => apiClient.get(`/wealth/cash-hint?year=${year}&month=${month}`),
};
